import ApiIcon from '@mui/icons-material/Api';
import EmailIcon from '@mui/icons-material/Email';
import FunctionsIcon from '@mui/icons-material/Functions';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import SchemaIcon from '@mui/icons-material/Schema';
import StorageIcon from '@mui/icons-material/Storage';
import WebhookIcon from '@mui/icons-material/Webhook';

// Updated nodesConfig with new categories and icons
export const nodesConfig = {
    eventNode: {
        id: "eventNode",
        name: "Event Node",
        description: "Represent a Event",
        icon: SchemaIcon,
        color: "#somecolor",
        supportedSourceTypes: []
    },
    evaluatorNode: {
        id: "evaluatorNode",
        name: "Decision/Evaluator",
        description: "Evaluate conditions and make decisions with true/false forks",
        icon: RuleOutlinedIcon,
        color: "#1976d2",
        supportedSourceTypes: []
    },
    transformerNode: {
        id: "transformerNode",
        name: "Transformer/Custom",
        description: "Custom functions and logic transformations",
        icon: FunctionsIcon,
        color: "#FF9800",
        supportedSourceTypes: []
    },
    dataEnricherApiNode: {
        id: "dataEnricherApiNode",
        name: "Enricher - API",
        description: "Fetch additional data from external APIs",
        icon: ApiIcon,
        color: "#009688",
        supportedSourceTypes: []
    },
    dataEnricherDbLookupNode: {
        id: "dataEnricherDbLookupNode",
        name: "Enricher - DB Lookup",
        description: "Retrieve data from databases for enrichment",
        icon: StorageIcon,
        color: "#8d6e63",
        supportedSourceTypes: []
    },
    dataEnricherGraphLookupNode: {
        id: "dataEnricherGraphLookupNode",
        name: "Enricher - Graph Lookup",
        description: "Query graph databases to enrich workflow",
        icon: StorageIcon,
        color: "#3f51b5",
        supportedSourceTypes: []
    },
    dataEnricherMlPredictionNode: {
        id: "dataEnricherMlPredictionNode",
        name: "Enricher - ML Prediction",
        description: "Make predictions using machine learning models",
        icon: ModelTrainingIcon,
        color: "#9c27b0",
        supportedSourceTypes: []
    },
    pushWebhookNode: {
        id: "pushWebhookNode",
        name: "Push - Webhook",
        description: "Send data to external service using webhooks",
        icon: WebhookIcon,
        color: "#f44336",
        supportedSourceTypes: []
    },
    pushDbNode: {
        id: "pushDbNode",
        name: "Push - DB",
        description: "Insert or update data in a database",
        icon: StorageIcon,
        color: "#2196f3",
        supportedSourceTypes: []
    },
    pushQueueNode: {
        id: "pushQueueNode",
        name: "Push - Queue",
        description: "Push messages to a queue for asynchronous processing",
        icon: WebhookIcon,
        color: "#ff9800",
        supportedSourceTypes: []
    },
    notificationEmailNode: {
        id: "notificationEmailNode",
        name: "Notification - Email",
        description: "Send email notifications",
        icon: EmailIcon,
        color: "#4caf50",
        supportedSourceTypes: []
    },
    notificationSlackNode: {
        id: "notificationSlackNode",
        name: "Notification - Slack",
        description: "Send Slack notifications",
        icon: EmailIcon,
        color: "#673ab7",
        supportedSourceTypes: []
    },
}
